<template>
    <div>
        <base-blog-create-blog-modal />
        <base-blog-delete-existing-post-modal />
        <base-blog-user-no-rights-modal />
        <div class="button icon kb-header-button"
             :title="trans.modal_title.settings"
             @click="initBlog">
            <svg>
                <use xlink:href="#icon-blog-settings"></use>
            </svg>
        </div>
        <div class="bulma">
            <div class="modal"
                 :class="{ 'is-active': isShown }">
                <div class="modal-background" @click="closeModal"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <svg class="modal-card-icon">
                            <use xlink:href="#icon-blog-settings"></use>
                        </svg>
                        <h2 class="modal-card-title">
                            {{ this.trans.modal_title.settings }}
                        </h2>
                        <a
                            @click="closeModal"
                            :title="trans.buttons.close"
                        >
                            <svg class="icon-cross">
                                <use xlink:href="#icon-cross"></use>
                            </svg>
                        </a>
                    </header>
                    <section class="modal-card-body">
                        <label class="label">
                            {{ this.trans.blog.manage.blog_link_label }}
                            <a class="base-blog-link" :href="baseBlogLink" target="_blank">
                                {{ baseBlogLink }}
                            </a>
                        </label>
                        <div class="columns is-flex">
                            <div class="column is-8">
                                <label class="label">
                                    {{ this.trans.blog.manage.blog_name_label }}
                                </label>
                                <input
                                    @keyup="baseBlogNameInput"
                                    :class="{ 'is-is-danger': errorMessage }"
                                    v-model="baseBlogNameField"
                                    class="input"
                                    type="text"
                                />
                                <p v-if="errorMessage" class="help is-danger">{{ errorMessage }}</p>
                            </div>
                            <div class="column is-4 is-flex">
                                <button
                                    @click="rename"
                                    :class="{'is-loading': isRequestInProgress}"
                                    :disabled="isDisabled"
                                    class="has-icons-right button is-info change-blog-name"
                                >
                                    <div v-if="isCheck">
                                        <span class="icon is-small is-right">
                                            <i class="fas fa-check"></i>
                                        </span>
                                    </div>
                                    <div v-else>
                                        {{ trans.buttons.save }}
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div v-if="posts.length" class="columns">
                        <table class="table column is-12">
                            <thead>
                                <tr>
                                    <th class="table-title">{{ this.trans.blog.manage.document_title }}</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <base-blog-post-table-row
                                    :key="post.blog_post_hash_id"
                                    v-for="post in posts"
                                    :post="post"
                                ></base-blog-post-table-row>
                            </tbody>
                        </table>
                    </div>
                    </section>
                    <footer class="modal-card-foot">
                        <button
                            @click="closeModal"
                            class="button"
                        >
                            {{ trans.buttons.close }}
                        </button>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BaseBlogCreateBlogModal from "./BaseBlogCreateBlogModal";
import BaseBlogDeleteExistingPostModal from "./BaseBlogDeleteExistingPostModal";
import BaseBlogPostTableRow from "./BaseBlogPostTableRow";
import BaseBlogUserNoRightsModal from "./BaseBlogUserNoRightsModal";

export default {
    name: "BaseBlogMainModal",
    components: {
        BaseBlogUserNoRightsModal,
        BaseBlogDeleteExistingPostModal,
        BaseBlogCreateBlogModal,
        BaseBlogPostTableRow,
    },
    props: {
        initTrans: Object,
        initActions: Object,
        initPermissions: Object,
    },
    data() {
        return {
            baseBlogNameField: null,
            isCheck: false,
            isDisabled: true,
        }
    },
    created() {
        this.setActions(this.initActions);
        this.setTrans(this.initTrans);
        this.setBaseBlogUserPermissions(this.initPermissions);
    },
    computed: {
        ...mapGetters('baseBlogManager', {
            isShown: 'baseBlogMainModalIsShown',
        }),
        ...mapGetters('baseBlogManager', [
            'trans',
            'baseBlogHash',
            'posts',
            'baseBlogName',
            'baseBlogLink',
            'isRequestInProgress',
            'isRequestSuccessfull',
            'baseBlogUserPermissions',
            'errorMessage',
        ]),
    },
    methods: {
        ...mapActions('baseBlogManager', {
            showModal: 'showBaseBlogMainModal',
        }),
        ...mapActions('baseBlogManager', [
            'setTrans',
            'setActions',
            'initBlog',
            'renameBlog',
            'unsetIsRequestSuccessfull',
            'loadPosts',
            'setBaseBlogUserPermissions',
            'hideBaseBlogMainModal',
        ]),
        baseBlogNameInput() {
            this.isDisabled = !(this.baseBlogNameField !== this.baseBlogName && this.baseBlogNameField.length);
        },
        rename() {
            this.isDisabled = true;
            this.renameBlog(this.baseBlogNameField);
        },
        closeModal() {
            this.hideBaseBlogMainModal();
            this.baseBlogNameField = this.baseBlogName;
        },
    },
    watch: {
        isShown(newValue, oldValue) {
            if (newValue) {
                this.loadPosts();
            }
        },
        baseBlogName(newValue, oldValue) {
            this.baseBlogNameField = this.baseBlogName;
        },
        isRequestSuccessfull(newValue, oldValue) {
            if (newValue) {
                this.isCheck = true;
                setTimeout(() => {
                    this.isCheck = false;

                    if (this.isShown) {
                        this.unsetIsRequestSuccessfull();
                    }
                }, 1000)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    .modal-card-body {
        overflow-x: hidden;
    }

    svg {
        width: 16px;
        height: 16px;
    }

    .icon-cross {
        fill: $white;
        &:hover {
            fill: $black;
        }
    }

    .base-blog-link {
        display: block;
        font-size: 16px;
        font-weight: 100;
        margin-top: 4px;
        margin-bottom: 23px;
    }

    th {
        font-family: RobotoWeb, "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 16px;
        font-weight: 100;
    }

    .bulma .table th:not([align]) {
        padding-left: 0px;
    }

    .label {
        display: block;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 4px;
    }

    .bulma .label:not(:last-child) {
        margin-bottom: 4px;
    }

    .change-blog-name {
        align-self: flex-end;
        width: 200px;
    }

    .fa-check {
        color: $white;
    }

    .table-title {
        font-weight: bold;
    }
</style>
